import { MapPosition } from '../../types';
import { SET_MAP_POSITION, MapActionTypes } from './types';

export function setMapPosition(position: MapPosition): MapActionTypes {
  return {
    type: SET_MAP_POSITION,
    payload: position,
  };
}
